module.exports = __webpack_public_path__ + "static/media/scratch-off-market-one.75b562a4.svg";